const merchantTest = {
    path: 'merchantTest',
    component: resolve => require(['@/pages/admin/merchant/signing/yftAlipay/merchantTest'], resolve),
    meta: {isAccredit: true}
  }
  
  export default merchantTest